<app-auth-card
  [message]="'Redirecionando...'"
  [showButton]="false"
  [showLoading]="true"
></app-auth-card>

